import { forwardRef } from 'react';
import styles from './Button.module.css';
import React from 'react';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	className?: string;
	name?: string;
	onClick: (e?: React.MouseEvent<HTMLButtonElement>) => void;
	typeSubmit?: 'button' | 'submit' | 'reset';
	color: 'white' | 'black';
	background: 'white' | 'black';
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
	const cssClassColor = () => {
		const { color, background } = props;

		if (color === 'white' && background === 'black') {
			return styles.btn_white_on_black;
		} else if (color === 'black' && background === 'white') {
			return styles.btn_black_on_white;
		} else if (color === 'white' && background === 'white') {
			return styles.btn_white_on_white;
		} else if (color === 'black' && background === 'black') {
			return styles.btn_black_on_black;
		}

		// Default fallback
		return '';
	};

	return (
		<>
			<button
				ref={ref}
				className={`${props.className || ''} ${styles.btn_style} ${cssClassColor()}`}
				name={props.name}
				onClick={props.onClick}
				type={props.typeSubmit ?? 'button'}
				disabled={props.disabled}
			>
				<div className={styles.btn_div}>{props.name}</div>
			</button>
		</>
	);
});

export default Button;
